/*@ngInject*/
const ClassCodeFormatRepository = function (baseCachedSharedPromiseRepository) {

        var sharedPromiseCache = {};

        angular.extend(this, baseCachedSharedPromiseRepository);

        this.getCacheName = function () {
            return 'classCodeFormatRepository';
        };

        this.getCacheCapacity = function () {
            return 10;
        };

        this.getSharedPromiseCache = function () {
            return sharedPromiseCache;
        };

        this.getClassCodeFormat = function (classCodeType) {
            var url = '/rest/ClassCode/Format',
                config = {
                    params: {
                        classCodeType: classCodeType
                    }
                },
                cacheKey = classCodeType;

            return this.get(cacheKey, url, config);
        };
    };

angular.module('umFormViewer')
    .service('classCodeFormatRepository', ClassCodeFormatRepository);
